<template>
  <div>
    <el-table
      :data="tableOptions.data"
    >
      <template v-for="(item, index) in tableOptions.column">
        <el-table-column
          v-if="item.hasTemplate"
          :key="index"
          :prop="item.prop?item.prop:''"
          :label="item.label?item.label:''"
          :width="item.width?item.width:''"
          :fixed="item.fixed?item.fixed:false"
        >
          <template slot-scope="scope">
            {{ item.formatRole(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          :prop="item.prop?item.prop:''"
          :label="item.label?item.label:''"
          :width="item.width?item.width:''"
          :fixed="item.fixed?item.fixed:false"
        />
      </template>
      <!-- 操作列 -->
      <el-table-column
        :label="tableOptions.operat.label?tableOptions.operat.label:''"
        :fixed="tableOptions.operat.fixed?tableOptions.operat.fixed:'right'"
        align="center"
        :width="tableOptions.operat.width?tableOptions.operat.width:''"
      >
        <template slot-scope="scope">
          <div v-for="(btn,index) in tableOptions.operat.title" :key="index" style="display:inline-block;">
            <el-link v-if="btn.show(scope.row) && btn.method === 'delete'" class="dt-link" :underline="false" type="danger" @click="handleButton(btn.method, scope.row)"> {{ btn.text }}</el-link>
            <el-button
              v-if="btn.show(scope.row) && btn.method !=='delete'"
              type="text"
              style="margin:0 5px"
              @click="handleButton(btn.method, scope.row)"
            >
              {{ btn.text }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    lodding: {
      required: false,
      type: Boolean,
      default: false
    },
    tableOptions: {
      required: true,
      type: Object,
      default: () => {}
    },
    /* 是否可以多选 */
    selection: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    handleSelectionChange(selectedValue) {
      this.$emit('handleSelectionChange', selectedValue)
    },
    formatRole() {},
    handleButton(method, data) {
      const param = {
        method,
        data
      }
      this.$emit('eventHandle', param)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dt-link{
     @include  dtlink;
  }
</style>
